/**
 * Imports the necessary dependencies for a React component that includes a custom button and a modal from react-bootstrap.
 * @module React
 * @module CustomButton
 * @module Modal
 */
import React from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../customButton/customButton";

const ConfirmModal = (props) => {
  /**
   * Destructures the properties object and assigns the corresponding values to variables.
   * @param {object} props - The properties object containing the values to destructure.
   * @returns None
   */
  const {
    iconColor,
    modalTitle,
    isFirstButton,
    isSecondButton,
    isUnderline,
    isBold,
    isModelIcon,
    closeModelIcon,
    leftdisabled,
    rightdisabled,
    rightButtonClick,
    onProcced,
    isCloseBtn,
    onHide,
    modalContent = true,
    loaderButtonShow,
    className = "confirmModal",
    showModal,
    iconCricle,
    modalDescription,
    messageLink,
    messagebold,
    leftBtnTitle,
    rightBtnTitle,
    leftBtnIcon,
    leftBtnClass,
    rightBtnClass,
    rightBtnIcon,
    note,
    noteText,
    badgeDate,
    ticketData,
    modalTitleDiv = true,
    status,
    date,
  } = props;
  return (
    /**
     * Renders a modal component with customizable content and buttons.
     * @param {string} className - Additional class names to apply to the modal.
     * @param {boolean} showModal - Determines whether the modal is shown or hidden.
     * @param {function} onHide - Callback function to handle hiding the modal.
     * @param {boolean} centered - Determines whether the modal is centered on the screen.
     * @param {boolean} isModelIcon - Determines whether to display an icon in the modal.
     * @param {string} iconCricle - Additional class names to apply to the icon circle.
     * @param {string} iconColor - Additional class names to apply to the icon.
     * @param {string} modalTitle - The title of
     */
    <Modal
      className={"confirmModal " + className}
      show={showModal}
      onHide={onHide}
      centered
    >
      <Modal.Body>
        {isModelIcon && (
          <div className={"iconCricleStyle " + iconCricle}>
            <i className={"icon " + iconColor} />
          </div>
        )}
        <div className="Title-IconWrapper">
          {modalTitleDiv && (
            <div className="modalTitle">
              <h4>{modalTitle}</h4>
            </div>
          )}

          {badgeDate && (
            <div className="badgeWrapper">
              <span
                className={
                  ticketData?.orderstatus === "Paid"
                    ? "paid "
                    : ticketData?.orderstatus === "Refunded"
                    ? "refund"
                    : ticketData?.orderstatus === "Fail"
                    ? "fail "
                    : ticketData?.orderstatus === "Cancelled"
                    ? "cancel"
                    : "paid"
                }
              >
                {status}
              </span>
              <span className="ticketDate">{date}</span>
            </div>
          )}
          {isCloseBtn && (
            <div className="CloseIcon" onClick={closeModelIcon}>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
              ></button>
            </div>
          )}
        </div>

        {modalContent && (
          <p className="modalContent">
            {modalDescription} {isUnderline && <u>{messageLink}</u>}{" "}
            {isBold && <b>{messagebold}</b>}
          </p>
        )}
        {note && (
          <div className="notes">
            <p> {noteText}</p>
          </div>
        )}
        {props?.children}
      </Modal.Body>
      <div className="modal-footer">
        {isFirstButton && (
          <CustomButton
            type="submit"
            title={leftBtnTitle}
            isLeftIcon={true}
            disabled={leftdisabled}
            icon={leftBtnIcon}
            className={leftBtnClass}
            onClick={(e, item) => {
              onProcced(e, item);
            }}
            loading={loaderButtonShow}
          />
        )}
        {isSecondButton && (
          <CustomButton
            // type="submit"
            title={rightBtnTitle}
            isLeftIcon={true}
            icon={rightBtnIcon}
            disabled={rightdisabled}
            className={rightBtnClass}
            onClick={rightButtonClick}
          />
        )}
      </div>
    </Modal>
  );
};

export default ConfirmModal;
